import { memo, type ReactElement } from 'react'

function WastePayGlyphLogo (): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1708 640"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g
          transform="translate(-1512 -3647)"
          className="fill-current text-wpy-super-light-gray-400"
        >
          <g transform="translate(201 203)">
            <g transform="translate(1311 3444)">
              <path
                d="M880.247758 0L745.857084 412.328422 616.996397 0 450.639564 0 315.339925 408.680799 186.468353 0 0 0 207.505166 640 401.27245 640 529.262272 250.504611 651.716664 640 845.516605 640 1053 0z"
              />
              <path
                d="M1184.27 0l-43.305 132.83H1708V42.77C1708 19.19 1688.881 0 1665.388 0H1184.27zM983 640h682.417c23.477 0 42.583-19.002 42.583-42.51V282.264h-608.817L983 640z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default memo(WastePayGlyphLogo)
